import "./IconButtonComponent.scss";
import {PropsWithChildren, useCallback} from "react";

interface IconButtonComponentProps {
    className?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    id?: string;
    onClick?: (e: any) => void;
}

const IconButtonComponent = (props: PropsWithChildren<IconButtonComponentProps>) => {

    const {
        className,
        id,
        disabled,
        onClick,
        children,
    } = props;

    const handleOnClick = useCallback((e: any) => {
        if (onClick) {
            onClick(e);
        }
    }, [onClick]);

    return (
        <div className={`icon-button ${className} ${disabled ? 'disabled' : ''}`}
             id={id}
             onClick={handleOnClick}
        >
            {children}
        </div>
    );

};

export default IconButtonComponent;
